let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lvJ5n")).then(() => parcelRequire('fRHBu'));